/*
  AboutHeroSection.jsx  — About Page Hero
  -----------------------------------------
  Props:
    bgImage — URL / import of the couple background photo

  Usage:
    import AboutHeroSection from "./AboutHeroSection";
    import aboutBg from "./assets/about-hero.jpg";
    <AboutHeroSection bgImage={aboutBg} />
*/
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./About.css";
import img1 from "../img/WHN4.png";
import img2 from "../img/WHN1.png";
import img3 from "../img/WHN3.png";
import img4 from "../img/WHN4.png";
import heart from "../img/DREAMICON.png";
import feature from "../img/FUTUREICON.png";
import coupleImage from "../img/coupleImage.png";
import imgg1 from "../img/Emotion1.png";
import imgg2 from "../img/Experience1.png";
import imgg3 from "../img/Genuine1.png";
import imgg4 from "../img/Family1.png";
import { useNavigate } from "react-router-dom";



export default function AboutHeroSection({ bgImage }) {
  const images = { img1, img2, img3, img4 };
  const {t} = useTranslation();
  

// section 5
const WHY_CARDS = [
  {
    id: "wn1",
    title: t("why_niran_card1_title"),
    body: t("why_niran_card1_description"),
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
    ),
    image: imgg1,
  },
  {
    id: "wn2",
    title: t("why_niran_card2_title"),
    body: t("why_niran_card2_description"),
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <polyline points="9 12 11 14 15 10" />
      </svg>
    ),
    image: imgg3,
  },
  {
    id: "wn3",
    title: t("why_niran_card3_title"),
    body: t("why_niran_card3_description"),
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
    image: imgg2,
  },
  {
    id: "wn4",
    title: t("why_niran_card4_title"),
    body: t("why_niran_card4_description"),
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M12 8v4l3 3" />
        <path d="M5 3l1.5 1.5" />
        <path d="M19 3l-1.5 1.5" />
      </svg>
    ),
    image: imgg4,
  },
];

const STEPS = [
  {
    side: "left",
    tag: t("idea_tag"),
    title: t("idea_title"),
    body: t("idea_description"),
    num: "1",
    imgKey: "img1",
  },
  {
    side: "right",
    tag: t("need_tag"),
    title: t("need_title"),
    body: t("need_description"),
    num: "2",
    imgKey: "img2",
  },
  {
    side: "left",
    tag: t("creation_tag"),
    title: t("creation_title"),
    body: t("creation_description"),
    num: "3",
    imgKey: "img3",
  },
  {
    side: "right",
    tag: t("today_tag"),
    title: t("today_title"),
    body: t("today_description"),
    num: "4",
    imgKey: "img4",
  },
];
  const rowRefs = useRef([]);
  const navigate = useNavigate();
  useEffect(() => {
    const observers = [];
    rowRefs.current.forEach((el) => {
      if (!el) return;
      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            el.classList.add("wwa-row--visible");
            obs.disconnect();
          }
        },
        { threshold: 0.18 },
      );
      obs.observe(el);
      observers.push(obs);
    });
    return () => observers.forEach((o) => o.disconnect());
  }, []);

  //section 3
  const card1Ref = useRef(null);
  const card2Ref = useRef(null);
  const headerRef = useRef(null);

  useEffect(() => {
    const items = [
      { el: headerRef.current, delay: 0 },
      { el: card1Ref.current, delay: 0.18 },
      { el: card2Ref.current, delay: 0.32 },
    ];

    const observers = items.map(({ el, delay }) => {
      if (!el) return null;
      el.style.setProperty("--anim-delay", `${delay}s`);
      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            el.classList.add("op-animate--visible");
            obs.disconnect();
          }
        },
        { threshold: 0.2 },
      );
      obs.observe(el);
      return obs;
    });
    return () => observers.forEach((o) => o && o.disconnect());
  }, []);
  //
  // section 4 — safe place
  // section 4 — safe place (paste this useEffect replacing your existing sf useEffect)
  const safeSectionRef = useRef(null);
  const safeHeartRef = useRef(null);
  const safeFeatureRefs = useRef([]);
  useEffect(() => {
    const items = [
      { el: safeHeartRef.current, delay: 0.1 },
      { el: safeFeatureRefs.current[0], delay: 0.25 },
      { el: safeFeatureRefs.current[1], delay: 0.35 },
      { el: safeFeatureRefs.current[2], delay: 0.45 },
      { el: safeFeatureRefs.current[3], delay: 0.55 },
    ];

    const observers = items.map(({ el, delay }) => {
      if (!el) return null;
      el.style.setProperty("--sf-delay", `${delay}s`);
      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            el.classList.add("sf-animate--visible");
            obs.disconnect();
          }
        },
        { threshold: 0.15 },
      );
      obs.observe(el);
      return obs;
    });

    return () => observers.forEach((o) => o && o.disconnect());
  }, []);
  // Add this ref alongside your other refs at the top of the component:
  const sfLinesRef = useRef(null);

  // Replace your existing sf-section useEffect with this:
  useEffect(() => {
    const items = [
      { el: safeHeartRef.current, delay: 0.1 },
      { el: sfLinesRef.current, delay: 0.45 },
      { el: safeFeatureRefs.current[0], delay: 0.2 },
      { el: safeFeatureRefs.current[1], delay: 0.3 },
      { el: safeFeatureRefs.current[2], delay: 0.4 },
      { el: safeFeatureRefs.current[3], delay: 0.5 },
    ];

    const observers = items.map(({ el, delay }) => {
      if (!el) return null;
      el.style.setProperty("--sf-delay", `${delay}s`);
      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            el.classList.add("sf-animate--visible");
            obs.disconnect();
          }
        },
        { threshold: 0.15 },
      );
      obs.observe(el);
      return obs;
    });

    return () => observers.forEach((o) => o && o.disconnect());
  }, []);
  // section 5 — why niran
  const wnHeaderRef = useRef(null);
  const wnCardRefs = useRef([]);

  useEffect(() => {
    const items = [{ el: wnHeaderRef.current, delay: 0 }];
    wnCardRefs.current.forEach((el, i) => {
      if (el) items.push({ el, delay: 0.1 + i * 0.12 });
    });

    const observers = items.map(({ el, delay }) => {
      if (!el) return null;
      el.style.setProperty("--wn-delay", `${delay}s`);
      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            el.classList.add("wn-animate--visible");
            obs.disconnect();
          }
        },
        { threshold: 0.15 },
      );
      obs.observe(el);
      return obs;
    });
    return () => observers.forEach((o) => o && o.disconnect());
  }, []);

  //
  // section 5
  const leftRef = useRef(null);
  const rightRef = useRef(null);

  useEffect(() => {
    const els = [
      { el: leftRef.current, cls: "cb-animate--left" },
      { el: rightRef.current, cls: "cb-animate--right" },
    ];
    const observers = els.map(({ el, cls }) => {
      if (!el) return null;
      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            el.classList.add("cb-animate--visible");
            obs.disconnect();
          }
        },
        { threshold: 0.2 },
      );
      obs.observe(el);
      return obs;
    });
    return () => observers.forEach((o) => o && o.disconnect());
  }, []);

  // secion7
  const contentRef = useRef(null);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("bj-content--visible");
          obs.disconnect();
        }
      },
      { threshold: 0.25 },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  // check auth
  const checkAuth = () => {
    const token = localStorage.getItem("token");
    return !!token;
  };

  return (
    <>
      <section className="about-hero">
        <div className="about-hero__bg" />

        <div className="about-hero__content">
          <p className="about-hero__eyebrow">{t("about_tagline")}</p>

          <h1 className="about-hero__heading">{t("about_title")}</h1>

          <p className="about-hero__body">
            {t("about_description_1")}
          </p>

          <p className="about-hero__body">
            {t("about_description_2")}
          </p>
        </div>
      </section>
      <section className="wwa-section">
        {/* ── Header ── */}
        <div className="wwa-header">
          <p className="wwa-eyebrow">{t("who_we_are_title")}</p>
          <h2 className="wwa-title">{t("story_title")}</h2>
          <div className="wwa-divider" />
        </div>

        {/* ── Timeline ── */}
        <div className="wwa-timeline">
          {STEPS.map((step, i) => {
            const isLeft = step.side === "left";
            const cardEl = (
              <div className="wwa-card">
                <p className="wwa-card-tag">{step.tag}</p>
                <h3 className="wwa-card-title">{step.title}</h3>
                <p className="wwa-card-body">{step.body}</p>
              </div>
            );
            const photoEl = (
              <div className="wwa-photo-wrap">
                <div
                  className="wwa-photo"
                  style={
                    images[step.imgKey]
                      ? { backgroundImage: `url(${images[step.imgKey]})` }
                      : {}
                  }
                  role="img"
                  aria-label={step.title}
                />
              </div>
            );

            return (
              <div
                key={step.num}
                className={`wwa-row wwa-row--${step.side}`}
                ref={(el) => (rowRefs.current[i] = el)}
              >
                {/* LEFT slot */}
                <div className="wwa-slot-left">{isLeft ? cardEl : photoEl}</div>

                {/* CENTRE — bubble on the line */}
                <div className="wwa-slot-mid">
                  <div className="wwa-bubble">{step.num}</div>
                </div>

                {/* RIGHT slot */}
                <div className="wwa-slot-right">
                  {isLeft ? photoEl : cardEl}
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="op-section">
        <div className="op-section__corner" />

        {/* Header */}
        <div className="op-header op-animate" ref={headerRef}>
          <p className="op-eyebrow">{t("purpose_title")}</p>
          <h2 className="op-title">{t("purpose_subtitle")}</h2>
          <p className="op-subtitle">{t("purpose_description")}</p>
        </div>

        {/* Cards */}
        <div className="op-grid">
          {/* Our Dream */}
          <div className="op-card op-animate" ref={card1Ref}>
            <div className="op-icon-wrap">
              {/* heart icon */}
              <img className="op-icons" src={heart} alt="hearticon" />
            </div>
            <h3 className="op-card-title">{t("dream_title")}</h3>
            <p className="op-card-body">
              {t("dream_description")}
            </p>
          </div>

          {/* Our Future */}
          <div className="op-card op-animate" ref={card2Ref}>
            <div className="op-icon-wrap">
              {/* compass / leaf icon */}
              <img className="op-icons" src={feature} alt="hearticon" />
            </div>
            <h3 className="op-card-title">{t("future_title")}</h3>
            <p className="op-card-body">
              {t("future_description")}
            </p>
          </div>
        </div>
      </section>

      {/* ── Section 5: Why Niran / Our Matches Matter ────────────────────── */}
      <section className="wn-section">
        {/* corner accent */}
        <div className="wn-corner" />

        {/* Header */}
        <div className="wn-header wn-animate" ref={wnHeaderRef}>
          <p className="wn-eyebrow">{t("why_niran_title")}</p>
          <h2 className="wn-title">{t("why_niran_subtitle")}</h2>
        </div>

        {/* Cards */}
        <div className="wn-grid">
          {WHY_CARDS.map((card, i) => (
            <div
              key={card.id}
              className="wn-card wn-animate"
              ref={(el) => (wnCardRefs.current[i] = el)}
            >
              {/* image placeholder — replace src with actual imports if available */}

              <div className="wn-card-img" aria-hidden="true">
                <img src={card.image} className="wn-card-image" />
                <div className="wn-card-img-overlay" />
              </div>
              {/* icon circle */}
              <div className="wn-icon-wrap">{card.icon}</div>
              {/* content */}
              <h3 className="wn-card-title">{card.title}</h3>
              <p className="wn-card-body">{card.body}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── Section 4: Our Safe Place for Love ── */}
      <section className="sf-section" ref={safeSectionRef}>
        <div className="sf-grid">
          {/* ── Connector lines overlay — must be first child ── */}
          <div className="sf-lines sf-animate" ref={sfLinesRef}>
            <div className="sf-line--3" />
            <div className="sf-line--4" />
          </div>

          {/* ── top-left card ── */}
          <div
            className="sf-card sf-card--top-left sf-animate"
            style={{ "--sf-delay": "0.2s" }}
            ref={(el) => (safeFeatureRefs.current[0] = el)}
          >
            {t("secure_profile_verification")}
          </div>

          {/* ── Central heart — spans both rows ── */}
          <div className="sf-heart-col sf-animate" ref={safeHeartRef}>
            <div className="sf-heart-wrap">
              {/* Ring 3 — outermost, most faded */}
              <svg
                className="sf-ring sf-ring--3"
                viewBox="0 0 220 205"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M110 192 C62 158 6 118 6 66 A56 56 0 0 1 110 40 A56 56 0 0 1 214 66 C214 118 158 158 110 192Z"
                  stroke="rgba(160, 40, 70, 0.45)"
                  strokeWidth="1.2"
                />
              </svg>

              {/* Ring 2 — middle */}
              <svg
                className="sf-ring sf-ring--2"
                viewBox="0 0 220 205"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M110 192 C62 158 6 118 6 66 A56 56 0 0 1 110 40 A56 56 0 0 1 214 66 C214 118 158 158 110 192Z"
                  stroke="rgba(160, 40, 70, 0.65)"
                  strokeWidth="1.5"
                />
              </svg>

              {/* Ring 1 — innermost, strongest */}
              <svg
                className="sf-ring sf-ring--1"
                viewBox="0 0 220 205"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M110 192 C62 158 6 118 6 66 A56 56 0 0 1 110 40 A56 56 0 0 1 214 66 C214 118 158 158 110 192Z"
                  stroke="rgba(160, 40, 70, 0.85)"
                  strokeWidth="1.8"
                />
              </svg>

              {/* Filled offwhite heart */}
              <svg
                className="sf-heart-svg"
                viewBox="0 0 220 205"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M110 192 C62 158 6 118 6 66 A56 56 0 0 1 110 40 A56 56 0 0 1 214 66 C214 118 158 158 110 192Z"
                  fill="#fff8f0"
                />
              </svg>

              {/* Text inside heart */}
              <div className="sf-heart-text">
               {t("safe_place_for_love_1")}
                <br />
                {t("safe_place_for_love_2")}
                <br />
                {t("safe_place_for_love_3")}
                <br />
                {t("safe_place_for_love_4")}
              </div>
            </div>
          </div>

          {/* ── top-right card ── */}
          <div
            className="sf-card sf-card--top-right sf-animate"
            style={{ "--sf-delay": "0.3s" }}
            ref={(el) => (safeFeatureRefs.current[1] = el)}
          >
            {t("confidential_match_search")}
          </div>

          {/* ── bottom-left card ── */}
          <div
            className="sf-card sf-card--bottom-left sf-animate"
            style={{ "--sf-delay": "0.4s" }}
            ref={(el) => (safeFeatureRefs.current[2] = el)}
          >
            {t("carefully_curated_matches")}
          </div>

          {/* ── bottom-right card ── */}
          <div
            className="sf-card sf-card--bottom-right sf-animate"
            style={{ "--sf-delay": "0.5s" }}
            ref={(el) => (safeFeatureRefs.current[3] = el)}
          >
            {t("genuine_matches")}
          </div>
        </div>
      </section>
      <section className="cb-section">
        {/* Header */}
        <div className="cb-header1">
          <p className="cb-eyebrow">{t("contact_title")}</p>
          <h2 className="cb-title1">{t("contact_subtitle")}</h2>
          <div className="cb-divider" />
        </div>

        {/* Body */}
        <div className="cb-body">
          {/* Left — photo */}
          <div className="cb-left" ref={leftRef}>
            <div
              className="cb-photo"
              style={
                coupleImage ? { backgroundImage: `url(${coupleImage})` } : {}
              }
              role="img"
              aria-label="Happy couple at their wedding"
            />
          </div>

          {/* Right — contact info */}
          <div className="cb-right" ref={rightRef}>
            <p className="cb-para">
              {t("contact_description_1")}
            </p>
            <p className="cb-para">
              {t("contact_description_2")}
            </p>

            {/* Email */}
            <div className="cb-contact-item">
              <div className="cb-icon-box">
                <svg viewBox="0 0 24 24">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </div>
              <div className="cb-contact-text">
                <p className="cb-contact-label">{t("email_us_title")}</p>
                <p className="cb-contact-value">hello@niranmatrimony.com</p>
              </div>
            </div>

            {/* Phone */}
            <div className="cb-contact-item">
              <div className="cb-icon-box">
                <svg viewBox="0 0 24 24">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.07 12 19.79 19.79 0 0 1 1 3.18 2 2 0 0 1 3 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 8.91a16 16 0 0 0 5.61 5.61l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
              </div>
              <div className="cb-contact-text">
                <p className="cb-contact-label">{t("call_us_title")}</p>
                <p className="cb-contact-value">+91 98765 43210</p>
              </div>
            </div>

            {/* CTA */}
            <button className="cb-btn" onClick={() => navigate("/contact")}>
              {t("contact_message_title")}
            </button>
          </div>
        </div>
      </section>

      <section className="bj-section">
        <div className="bj-bg" />

        <div className="bj-content" ref={contentRef}>
          <p className="bj-eyebrow">{t("journey_tagline")}</p>
          <h2 className="bj-heading">
            {t("step5_title")}
          </h2>
          <button
            className="bj-btn"
            onClick={() =>
              checkAuth() ? navigate("/pricing") : navigate("/register")
            }
          >
            {t("step4_title")}
          </button>
        </div>
      </section>
    </>
  );
}
